module.exports = __webpack_public_path__ + "media/images/mailbox-large-d9d372c5.png";